import { render, staticRenderFns } from "./mateWarn.vue?vue&type=template&id=dfbcef9c&scoped=true&"
import script from "./mateWarn.vue?vue&type=script&lang=js&"
export * from "./mateWarn.vue?vue&type=script&lang=js&"
import style0 from "./mateWarn.vue?vue&type=style&index=0&id=dfbcef9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfbcef9c",
  null
  
)

export default component.exports